<template>
    <v-card
        class="summary-box"
        :color="color">
        <div class="sb-label locale-font">
            <div>
                <slot name="icon"></slot>
            </div>
            <div>
                <slot name="label"></slot>
            </div>
        </div>
        <div class="sb-count locale-font">
            <slot name="count"></slot>
        </div>
    </v-card>
</template>

<script>
export default {
    name: 'SummaryBox',

    props: {
        color: {
            type: String,
            default: '#FFFFFF'
        }
    }
}
</script>

<style lang="scss" scoped>
.summary-box {
    display: flex;
    flex-flow: column;
    justify-content: space-between;
    width: 100%;
    padding: 16px;
    border-radius: 10px !important;
    box-shadow: 0 5px 25px 0 rgba(108, 108, 108, 0.2);

    .sb {
        display: flex;

        &-label {
            font-size: 1rem;
            display: flex;
            align-items: center;
            font-weight: 300;

            & > *:not(:first-child) {
                margin-left: 14px;
            }
        }

        &-count {
            font-size: 32px;
            font-weight: 300;
            line-height: 1.25;
            margin-top: 5px;
        }
    }
}
@media only screen and (max-width: 1440px) {
    .summary-box {
        width: 30%;
        flex-basis: 30%;
    }
}
</style>
